export default __webpack_public_path__ + "static/media/computer-one.ecf25e05.svg";